import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import './assets/style/css/normal.css';
import './assets/style/css/theme.css';

// 微信授权回调重定向处理
// 只处理 FuturesCalculator 的回调（state 是 Base64 编码且包含 FuturesCalculator）
(function handleWechatCallback() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const state = params.get('state');
  if (code && state) {
    try {
      const decoded = decodeURIComponent(atob(state));
      if (decoded.includes('FuturesCalculator')) {
        const hashPart = decoded.includes('?') ? decoded.split('?')[0] : decoded;
        const queryPart = decoded.includes('?') ? decoded.split('?')[1] : '';
        const separator = queryPart ? '&' : '';
        const newUrl = `${window.location.origin}${window.location.pathname}${hashPart}?${queryPart}${separator}code=${code}`;
        window.location.replace(newUrl);
        return;
      }
    } catch (e) {
      // state 不是有效 Base64，不是 FuturesCalculator 的回调
    }
  }
  startApp();
})();

function startApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));

  root.render(
    <HashRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </HashRouter>
  );
}
